import { AppConfiguration } from "shared/types";

import { createIntegrationData, getIntegrationConfigs } from "./utils";

import { IntegrationHandler } from ".";

export class ZenDeskORFreshDeskIntegrationHandler extends IntegrationHandler {
  constructor(options: IntegrationHandler) {
    super(options);
    Object.assign(this, options);
  }

  async run(
    onIntegrationClick: (integration: IntegrationHandler) => Promise<void>,
    config: AppConfiguration,
    botId: string,
  ): Promise<void> {
    const currentDate = new Date();
    const oneMonthFromNow = new Date(currentDate.getTime());
    oneMonthFromNow.setMonth(currentDate.getMonth() + 1);
    const resp = await getIntegrationConfigs({
      id: this.id,
      config,
      bot_id: botId,
    });
    this.data = createIntegrationData(resp.widget_fields, {});
    await onIntegrationClick(this);
  }
}
